import { render, staticRenderFns } from "./Prestamos.vue?vue&type=template&id=5a5683cc&scoped=true"
import script from "./Prestamos.vue?vue&type=script&lang=js"
export * from "./Prestamos.vue?vue&type=script&lang=js"
import style0 from "./Prestamos.vue?vue&type=style&index=0&id=5a5683cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5683cc",
  null
  
)

export default component.exports